import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-compartimentering',
  templateUrl: './spec-compartimentering.component.html',
  styleUrls: ['./spec-compartimentering.component.scss'],
})
export class SpecCompartimenteringComponent {}
